var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.9717H19V5.97168H5V19.9717H12V14.9717H10V12.9717H12V11.3177C12 9.98068 12.14 9.49568 12.4 9.00668C12.6561 8.52287 13.052 8.12737 13.536 7.87168C13.918 7.66668 14.393 7.54368 15.223 7.49068C15.552 7.46968 15.978 7.49568 16.501 7.57068V9.47068H16C15.083 9.47068 14.704 9.51368 14.478 9.63468C14.3431 9.70404 14.2334 9.81383 14.164 9.94868C14.044 10.1747 14 10.3987 14 11.3167V12.9717H16.5L16 14.9717H14V19.9717ZM4 3.97168H20C20.2652 3.97168 20.5196 4.07704 20.7071 4.26457C20.8946 4.45211 21 4.70646 21 4.97168V20.9717C21 21.2369 20.8946 21.4913 20.7071 21.6788C20.5196 21.8663 20.2652 21.9717 20 21.9717H4C3.73478 21.9717 3.48043 21.8663 3.29289 21.6788C3.10536 21.4913 3 21.2369 3 20.9717V4.97168C3 4.70646 3.10536 4.45211 3.29289 4.26457C3.48043 4.07704 3.73478 3.97168 4 3.97168V3.97168Z",
    fill: "#BDBDBD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/Icon_Facebook.b23fd7577e8f49c315681f86af4ec5b0.svg";
export { ForwardRef as ReactComponent };